import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import TagForm from './TagForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditTagModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.updateTag( values.tagid, { tagtext: values.tagtext } )
        .then( ( tag ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( tag );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteTag = () => {
        this.setState( { fetching: true } );
        this.props.deleteTag( this.props.tag.tagtext )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }



    render() {
        const { tag } = this.props;
        return (
            <DLModal title='Edit Tag'
            closeHandler={ this.props.closeModal }>
                <div>
                    <TagForm next={ this.submitHandler } initialValues={ tag } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS TAG?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteTag }>
                            DELETE TAG
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS TAG
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateTag: ( tagid, data ) => {
            return dAPI.patch( `/tags/${ tagid }`, data );

        },
        deleteTag: ( tagtext ) => {
            return dAPI.delete( `/tags/${ tagtext }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( EditTagModal );
